import { PropertyBookingEntry } from "../../Types/bookingTypes";

export const vrboReservationDetailsLink = (bookingData: PropertyBookingEntry) => {
    let vrboReservationDetails = ''

    if (bookingData && bookingData.source === 'vrbo' && bookingData.sourceConfirmation) {
        // https://www.vrbo.com/supply/inbox?search=HA-SVRD8R
        vrboReservationDetails = `https://www.vrbo.com/supply/inbox?search=${bookingData.sourceConfirmation}`
    }
    return vrboReservationDetails
}